import { FC, ReactElement } from 'react';

import { useUITranslation } from '@pp/core/src/services/uiTranslations/reactBindings/hooks';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { Bets } from '../../config/bets';
import { useIsAutoCashoutDisabled } from '../gameGrid/hooks/useIsAutoCashoutDisabled';
import { Textfit } from '../textfit/Textfit';

import { AutoCashoutControlConnected } from './AutoCashoutControlConnected';
import { AutoCashoutInputConnected } from './AutoCashoutInputConnected';

import styles from './AutoCashoutConnected.module.css';

interface AutoCashoutConnectedProps {
  betCode: Bets;
}
export const AutoCashoutConnected: FC<AutoCashoutConnectedProps> = ({ betCode }): ReactElement => {
  const isDisable = useIsAutoCashoutDisabled(betCode);
  const autocashout = useUITranslation('AUTO_CASHOUT');

  const mods = useModifiers(styles, 'autocash_wing', {
    disabled: isDisable,
  });
  return (
    <div className={`${styles.autocash_wing} ${mods}`}>
      <div className={`${styles.auto_cashout_text}`}>
        <Textfit wordWrap={true} offsetWidth={8}>
          {autocashout}
        </Textfit>
      </div>
      <AutoCashoutControlConnected betCode={betCode} isDisabled={isDisable} />
      <AutoCashoutInputConnected betCode={betCode} isDisabled={isDisable} />
    </div>
  );
};
